export const SPECIAL_STAFF_QUERY_KEY = 'special_staff';

export const buildSpecialStaffUrl = (url, staff = []) => {
  if (!staff.length) {
    return url;
  }

  return `${url}?${SPECIAL_STAFF_QUERY_KEY}=${staff.join(',')}`;
};

export const setSpecialStaffFromRoute = (store, route) => {
  const value = route.query[SPECIAL_STAFF_QUERY_KEY];

  if (value) {
    store.dispatch('users/setSpecialStaff', value.split(','));
  }
};
